import { type ProfileAccount, ProfileFrame } from "@/components/ProfileFrame/ProfileFrame";
import type { ProfileTabHrefs } from "@/components/ProfileTabs/ProfileTabs";
import { StorePanel, type StoreProduct, type StoreService } from "@/components/StorePanel/StorePanel";

export interface ProfileStoreViewProps {
  account: ProfileAccount;
  canCreateListing?: boolean;
  products: StoreProduct[];
  services: StoreService[];
  tabs: ProfileTabHrefs;
  onAddProduct?: () => void;
  onAddService?: () => void;
  onAcceptFriendship?: () => void;
  onDeclineFriendship?: () => void;
  onFriendshipAction?: () => void;
  onShareProfile?: () => void;
  onUnfriend?: () => void;
}

/**
 * Store tab (`/@handle/store`) shared by the individual, family and community
 * profiles: the profile chrome with the store panel as tab content.
 */
export function ProfileStoreView({
  account,
  canCreateListing,
  products,
  services,
  tabs,
  onAddProduct,
  onAddService,
  onAcceptFriendship,
  onDeclineFriendship,
  onFriendshipAction,
  onShareProfile,
  onUnfriend,
}: ProfileStoreViewProps) {
  return (
    <ProfileFrame
      account={account}
      currentTab="store"
      onAcceptFriendship={onAcceptFriendship}
      onDeclineFriendship={onDeclineFriendship}
      onFriendshipAction={onFriendshipAction}
      onShareProfile={onShareProfile}
      onUnfriend={onUnfriend}
      tabs={tabs}
    >
      <StorePanel
        canCreateListing={canCreateListing}
        onAddProduct={onAddProduct}
        onAddService={onAddService}
        products={products}
        services={services}
      />
    </ProfileFrame>
  );
}
